"use client"

import { User } from 'lucide-react'
import { useSimpleAuth as useAuth } from '@sourcepilot/ui/shell/auth/use-simple-auth'
import { PersonAvatar } from './person-avatar'

/** Signed-in user's avatar — a single PersonAvatar bound to the auth
 * session (image + identity-initials fallback handled internally, so no
 * separate Radix <Avatar> wrapper / fallback slot is needed). Renders the
 * plain grey icon only in the pre-auth moment. `size` is a Tailwind rem
 * step, so w-6 = 24px. Use PersonAvatar directly for anyone else. */
export function UserClientAvatar({ size = 6 }: { size?: number }) {
  const { user } = useAuth()
  const key = user?.identifier || user?.metadata?.email
  if (!key) return <User className={`w-${size} h-${size}`} />
  return (
    <PersonAvatar
      imageUrl={user?.metadata?.image}
      identityKey={key}
      name={user?.metadata?.name || user?.display_name}
      sizePx={size * 4}
    />
  )
}
